/* global Swiper */
(() => {
  const themeCreateProductSwiper = () => {
    if (!customElements.get('product-swiper')) {
      class ProductSwiper extends HTMLElement {
        connectedCallback() {
          const fullWidth = this.dataset.fullWidth === 'true';
          const originalCount = Number(this.dataset.originalCount || 0);

          const getSlidesPerView = (desired, forced) => {
            if (originalCount <= 0) return 1;
            if (forced) return desired;
            return Math.min(desired, originalCount);
          };

          const parseBreakpoints = (value, force = false) => {
            if (!value || typeof value !== 'string') {
              return {
                768: {
                  slidesPerView: getSlidesPerView(1),
                  spaceBetween: 40
                },
                1200: {
                  slidesPerView: getSlidesPerView(2),
                  spaceBetween: 40
                },
                1280: {
                  slidesPerView: getSlidesPerView(3),
                  spaceBetween: 40
                },
                1400: {
                  slidesPerView: getSlidesPerView(4),
                  spaceBetween: 40
                }
              };
            }

            const result = {};

            value
              .split(',')
              .map((part) => part.trim())
              .filter(Boolean)
              .forEach((part) => {
                const [rawWidth, rawSlides] = part.split(':').map((item) => item?.trim());

                const width = Number(rawWidth);
                const slides = Number(rawSlides);

                if (!Number.isFinite(width) || !Number.isFinite(slides)) return;
                if (width <= 0 || slides <= 0) return;

                result[width] = {
                  slidesPerView: getSlidesPerView(slides, force),
                  spaceBetween: 40
                };
              });

            if (Object.keys(result).length === 0) {
              return {
                768: {
                  slidesPerView: getSlidesPerView(1),
                  spaceBetween: 40
                },
                1200: {
                  slidesPerView: getSlidesPerView(2),
                  spaceBetween: 40
                },
                1280: {
                  slidesPerView: getSlidesPerView(3),
                  spaceBetween: 40
                },
                1400: {
                  slidesPerView: getSlidesPerView(4),
                  spaceBetween: 40
                }
              };
            }

            return Object.fromEntries(
              Object.entries(result).sort((a, b) => Number(a[0]) - Number(b[0]))
            );
          };

          const breakpoints = parseBreakpoints(this.dataset.breakpoints, this.dataset.forceBreakpoints ?? false);

          this.swiper = new Swiper(`#${CSS.escape(this.id)} .swiper`, {
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints,
            loop: true,
            loopAdditionalSlides: 5,
            effect: this.dataset.effect,
            navigation: {
              nextEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=next]`,
              prevEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=prev]`
            },
            a11y: {
              slideRole: null
            },
            on: {
              init: (swiper) => {
                this.updateSlideTabIndex(swiper);
                if (!fullWidth) this.updateEdgeSlideVisibility(swiper);
              },
              slideChange: (swiper) => {
                this.updateSlideTabIndex(swiper);
                if (!fullWidth) this.updateEdgeSlideVisibility(swiper);
              }
            }
          });
        }

        updateSlideTabIndex(swiper = this.swiper) {
          if (!swiper?.slides) return;

          swiper.slides.forEach((slide, index) => {
            const focusableElements = slide.querySelectorAll(
              'product-card, a, button, input, textarea, select, [tabindex]'
            );

            if (index === swiper.activeIndex) {
              slide.removeAttribute('tabindex');
              focusableElements.forEach((el) => el.removeAttribute('tabindex'));
            } else {
              slide.setAttribute('tabindex', '-1');
              focusableElements.forEach((el) => el.setAttribute('tabindex', '-1'));
            }
          });
        }

        updateEdgeSlideVisibility(swiper = this.swiper) {
          if (!swiper?.slides) return;

          swiper.slides.forEach((slide) => slide.classList.remove('is-visible'));

          const { activeIndex } = swiper;
          const currentSlidesPerView =
            typeof swiper.params.slidesPerView === 'number'
              ? swiper.params.slidesPerView
              : 1;

          let range;
          if (currentSlidesPerView <= 1) {
            range = 0;
          } else if (currentSlidesPerView <= 3) {
            range = 1;
          } else if (currentSlidesPerView <= 4) {
            range = 2;
          } else {
            range = 3;
          }

          for (let i = -range; i <= range; i += 1) {
            const index = (activeIndex + i + swiper.slides.length) % swiper.slides.length;
            swiper.slides[index].classList.add('is-visible');
          }
        }
      }

      customElements.define('product-swiper', ProductSwiper);
    }
  };

  if (theme.Swiper) {
    themeCreateProductSwiper();
  } else {
    document.addEventListener('swiper-loaded', themeCreateProductSwiper);
  }
})();